import PropTypes from "prop-types";
import { useState, useEffect, useCallback  } from "react";
import { RefreshCw } from "lucide-react";
import { getProductos, createProducto, updateProductoById, getIncidentesbyProducto, deleteProductoById, getMaterial, getMarcas, getFamilias, getUbicacion, getEmpleados} from "../api";


const FilterTableProducto = ({ empleado }) => {
  const URL = process.env.REACT_APP_URL;
  const [Producto, setProducto] = useState([]);
  const [filteredProducto, setFilteredProducto] = useState([]);
  const [formData, setFormData] = useState({ id: 0, descripcion: "", regresar:false, estado: "ENTRADA",id_marca: "", id_familia: "", path_imagen: "", file: null, id_material: "", id_ubicacion: "", fecha_creacion: "", fecha_ultima_actualizacion: "", fecha_baja: "", creado_por: "", codigo: "", color: "", nota: "", familia_tipo: "", cantidad: "" });
  const [isEditing, setIsEditing] = useState(false);
  const [image, setImage] = useState(null); // Estado para almacenar la imagen
  const [error, setError] = useState("");
  const [idSeleccionado, setIdSeleccionado] = useState(null);
  const [incidentes, setIncidentes] = useState([]);
  const [ubicacion, setUbicacion] = useState([]);
  const [donde, setDonde] = useState("");
  const [filterText, setFilterText] = useState("");
  const [material, setMaterial] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [, setEmpleados] = useState([]);
  const [imageUrl, setImageUrl] = useState("");
  const [open, setOpen] = useState(false);
  const [historia, setHistoria] = useState(false);
  const handleImageChange = (e) => {
  const selectedFile = e.target.files[0];
    setImage(selectedFile);
    setFormData((prevData) => ({ ...prevData, file: selectedFile }));
  };
  
  const fetchDropdownData = async () => {
    try {
      const [materiaResponse, ubicacionResponse, usuariosResponse, marcasResponse, familiasResponse] = await Promise.all([
        getMaterial(),
        getUbicacion(),
        getEmpleados(),
        getMarcas(),
        getFamilias(),
      ]);
      setMaterial(materiaResponse.data);
      setUbicacion(ubicacionResponse.data);
      setEmpleados(usuariosResponse.data);
      setMarcas(marcasResponse.data);
      setFamilias(familiasResponse.data);
    } catch (error) {
      console.error("Error fetching dropdown data:", error);
    }
  };


  const fetchProducto = useCallback(async () => {
    try {
      const response = await getProductos();
      const data = response.data;

      const parseDate = (value) => {
        const time = new Date(value ?? "").getTime();
        return Number.isNaN(time) ? 0 : time;
      };

      // Si el backend retorna filas repetidas por joins de incidentes,
      // mantenemos un solo registro por codigo (el mas reciente).
      const deduplicatedByCodigo = Object.values(
        data.reduce((acc, producto) => {
          const codigoNormalizado = String(producto?.codigo ?? "").trim().toLowerCase();
          const key = codigoNormalizado || `sin-codigo-${producto?.id ?? `${producto?.descripcion ?? ""}-${producto?.marca ?? ""}`}`;
          const current = acc[key];

          if (!current) {
            acc[key] = producto;
            return acc;
          }

          const currentUpdatedAt = parseDate(current?.fecha_ultima_actualizacion || current?.fecha_creacion);
          const candidateUpdatedAt = parseDate(producto?.fecha_ultima_actualizacion || producto?.fecha_creacion);

          if (candidateUpdatedAt > currentUpdatedAt) {
            acc[key] = producto;
            return acc;
          }

          if (candidateUpdatedAt === currentUpdatedAt && Number(producto?.id ?? 0) > Number(current?.id ?? 0)) {
            acc[key] = producto;
          }

          return acc;
        }, {})
      );
  
      setProducto((prev) =>
        JSON.stringify(prev) === JSON.stringify(deduplicatedByCodigo) ? prev : deduplicatedByCodigo
      );
    } catch (error) {
      console.error("Error fetching producto:", error);
      setError("Error loading data");
    }
  }, []);
  

  useEffect(() => {
    fetchProducto();
    fetchDropdownData();
  }, [fetchProducto]);

  useEffect(() => {
    const searchText = filterText.trim().toLowerCase();

    if (searchText) {
      const normalize = (value) =>
        String(value ?? "")
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase();

      const normalizedSearchText = normalize(searchText);

      const filtered = Producto.filter((producto) => {
        const hasActiveLoan = Boolean(producto?.prestado);
        const matchesResponsable =
          hasActiveLoan &&
          normalize(producto?.responsable).includes(normalizedSearchText);

        const searchableValues = [
          producto?.marca,
          producto?.codigo,
          producto?.familia,
          producto?.familia_tipo,
          producto?.material,
        ];

        const matchesCatalogFields = searchableValues
          .map(normalize)
          .some((value) => value.includes(normalizedSearchText));

        // Responsable solo aplica para materiales que siguen prestados.
        return matchesResponsable || matchesCatalogFields;
      });

      setFilteredProducto(filtered);
    } else {
      setFilteredProducto(Producto);
    }
  }, [filterText, Producto]);

  const canReturnProducto = (producto) => {
    // Solo permitir devolucion cuando el backend reporta prestamo activo.
    if (typeof producto?.prestado === "boolean") {
      return producto.prestado;
    }

    // Compatibilidad defensiva para payloads antiguos.
    return producto?.estado !== "ENTRADA";
  };

  const handleReturn = async (producto) => {
    try {
      const formDataToSend = new FormData();
      const ubicacionDeRegreso = String(producto?.id_ubicacion || 1);
      formDataToSend.append("regresar", "true");
      formDataToSend.append("id_ubicacion", ubicacionDeRegreso);

      await updateProductoById(producto.id, formDataToSend);
      alert("Producto actualizado con éxito.");
      fetchProducto();
    }catch (error) {
      console.error("Error procesando el producto:", error);
      const mensaje = error?.response?.data?.error || "No se pudo regresar el producto.";
      alert(mensaje);
    }
  };

  const handleDetalles = async (Producto) => {
    try {
      setDonde(Producto.ubicacion);
      const response = await getIncidentesbyProducto(Producto.id);
      setIdSeleccionado(Producto.id)
      setIncidentes(response.data);
    } catch (error) {
      console.error("Error fetching producto:", error);
      setError("Error loading data");
    }
    setHistoria(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formDataToSend = new FormData();
  
      // Solo validar y añadir imagen si existe una nueva
      if (image) {
        // Validar tamaño
        const maxSizeInBytes = 5 * 1024 * 1024; // 5 MB
        if (image.size > maxSizeInBytes) {
          alert("El tamaño de la imagen debe ser menor a 5 MB.");
          return;
        }
  
        // Adjuntar imagen
        formDataToSend.append("file", image);
      }

      // Agregar el resto de los campos
      formDataToSend.append("descripcion", formData.descripcion);
      formDataToSend.append("regresar", false);
      const estadoParaGuardar = String(formData.estado || "").trim() || "ENTRADA";
      formDataToSend.append("estado", estadoParaGuardar);
      formDataToSend.append("id_material", formData.id_material);
      formDataToSend.append("id_marca", formData.id_marca);
      formDataToSend.append("id_familia", formData.id_familia);
      formDataToSend.append("id_ubicacion", formData.id_ubicacion);
      formDataToSend.append("fecha_creacion", formData.fecha_creacion);
      formDataToSend.append("fecha_ultima_actualizacion", formData.fecha_ultima_actualizacion);
      formDataToSend.append("fecha_baja", formData.fecha_baja);
      formDataToSend.append("creado_por", empleado?.id);
      formDataToSend.append("codigo", formData.codigo);
      formDataToSend.append("color", formData.color);
      formDataToSend.append("nota", formData.nota);
      formDataToSend.append("familia_tipo", formData.familia_tipo);
      formDataToSend.append("cantidad", formData.cantidad);
  
      if (formData.file instanceof File) {
        formDataToSend.append("file", formData.file);
      }
  
      // Enviar según si es edición o creación
      if (isEditing) {
        await updateProductoById(formData.id, formDataToSend);
        fetchProducto();
        alert("Producto actualizado con éxito.");
      } else {
        await createProducto(formDataToSend);
        fetchProducto();
        alert("Producto registrado con éxito.");
      }
  
      // Reiniciar formulario
      setFormData({
        id: 0,
        descripcion: "",
        regresar: false,
        estado: "ENTRADA",
        file: null,
        id_material: "",
        id_marca: "",
        id_familia: "",
        id_ubicacion: "",
        fecha_creacion: "",
        fecha_ultima_actualizacion: "",
        fecha_baja: "",
        creado_por: "",
        codigo: "",
        color: "",
        nota: "",
        familia_tipo: "",
        cantidad: "",
      });
  
      setIsEditing(false);
      fetchProducto();
    } catch (error) {
      console.error("Error procesando el producto:", error);
    }
  };
  
  
  const handleEdit = (Producto) => {
    setFormData(Producto);
    setIsEditing(true);
    setImage(null);
  };

  const handleClearFilters = () => {
    setIsEditing(false);
    setFormData({ id: 0, descripcion: "", estado: "ENTRADA", regresar: false, file: "", id_marca: "", id_familia: "", path_imagen: "", id_material: "", id_ubicacion: "", fecha_creacion: "", fecha_ultima_actualizacion: "", fecha_baja: "", creado_por: "", codigo: "", color: "", nota: "", familia_tipo: "", cantidad: "" });
  };

  const handleDelete = async (id) => {
    if (window.confirm("¿Estás seguro de eliminar esta producto?")) {
      try {
        await deleteProductoById(id);
        alert("Producto eliminado con éxito.");
        fetchProducto();
      } catch (error) {
        console.error("Error eliminando la producto:", error);
      }
    }
  };
  const handleView = async (producto) => {
    setImageUrl(`${URL}${producto}?${Date.now()}`);
    setOpen(true);
  };

  // Handle closing the modal
  const handleCloseModal = () => {
    setOpen(false);
  };
  const handleCloseHistoriaModal = () => {
    setHistoria(false);
  };

  return (
    <div>
      <h2>
        Hola: {empleado ? `${empleado.tratamiento} ${empleado.nombres} ${empleado.apellido_paterno}` : "Sin información"}
      </h2>
      <form onSubmit={handleSubmit}>
        <center><h2>{isEditing ? "Editar Producto" : "Agregar Producto"}</h2></center>
        <div className="input-group">
          <input
            type="text"
            name="id"
            value={formData.id}
            onChange={handleChange}
            className="input"
            disabled={isEditing}
            hidden
          />
        </div>
        <div className="input-group">
          <label className="label2">Codigo</label>
          <input
            type="text"
            name="codigo"
            value={formData.codigo}
            onChange={handleChange}
            className="input-form-1"
          />
          <label className="label2">Color</label>
          <input
            type="text"
            name="color"
            value={formData.color}
            onChange={handleChange}
            className="input-form-1"
          />
        </div>
        <div className="input-group">
          <label className="label2">Descripción</label>
          <input
            type="text"
            name="descripcion"
            value={formData.descripcion}
            onChange={handleChange}
            className="input-form-1"
          />
        <label className="label2">Nota</label>
        <input
          type="text"
          name="nota"
          value={formData.nota}
          onChange={handleChange}
          className="input-form-1"
        />
        </div>
        <div className="input-group">
          <label className="label2">Cantidad</label>
          <input
            type="text"
            name="cantidad"
            value={formData.cantidad}
            onChange={handleChange}
            className="input-form-1"
          />
        </div>
        <hr />
        <h3>Actualiza cuando el producto sea prestado o regresado</h3>
        <div className="input-group">
          <label className="label2">Estado</label>
        <select
          name="estado"
          value={formData.estado}
          onChange={handleChange}
          className="input-form-1"
        >
          <option key="RENTA" value="RENTA">RENTA</option>
        </select>
        
        <label className="label2">Tipo</label>
          <select
            name="id_material"
            value={formData.id_material}
            onChange={handleChange}
            className="input-form-1"
          >
            {material.map((material) => (
              <option key={material.id} value={material.id}>
                {material.descripcion}  
              </option>
            ))}
          </select>
        </div>
        <div className="input-group">
        <label className="label2">Marca</label>
          <select
            name="id_marca"
            value={formData.id_marca}
            onChange={handleChange}
            className="input-form-1"
          >
            {marcas.map((marca) => (
              <option key={marca.id} value={marca.id}>
                {marca.descripcion}
              </option>
            ))}
          </select>

          <label className="label2">Familia</label>
          <select
            name="id_familia"
            value={formData.id_familia}
            onChange={handleChange}
            className="input-form-1"
          >
            {familias.map((familia) => (
              <option key={familia.id} value={familia.id}>
                {familia.descripcion}
              </option>
            ))}
          </select>
        </div>
        <div className="input-group">
        <label className="label2">Ubicacion</label>
          <select
            name="id_ubicacion"
            value={formData.id_ubicacion}
            onChange={handleChange}
            className="input-form-1"
          >
            {ubicacion.map((ubicacion) => (
              <option key={ubicacion.id} value={ubicacion.id}>
                {ubicacion.descripcion}
              </option>
            ))}
          </select>

          <div className="input-group">
          <label className="label">Foto de Producto:</label>
          <input type="file" name="file" onChange={handleImageChange} className="input" accept="image/*" />
          </div>

        </div>
        <center>
          <button type="submit" className="button-form-blue">
          {isEditing ? "Actualizar" : "Registrar"}
          </button>
          <button  type="reset" className="button-form-gray" onClick={handleClearFilters}>
              Cancelar
          </button>
        </center>
      </form>
      <hr />
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
        <input
          type="text"
          value={filterText}
          onChange={(e) => setFilterText(e.target.value)}
          placeholder="Buscar por responsable activo, marca, código, familia o tipo..."
          className="input3"
          style={{ flex: 1 }}
        />
        <button
          onClick={fetchProducto}
          style={{
            background: "none",
            border: "none",
            cursor: "pointer",
            fontSize: "25px",
            padding: 0,
            marginLeft: "10px"
          }}
          title="Actualizar productos"
        >
          <RefreshCw size={24} />
        </button>
      </div>
      <p style={{ marginTop: "0", marginBottom: "10px" }}>
        Se encontraron {filteredProducto.length} elemento{filteredProducto.length === 1 ? "" : "s"}.
      </p>
      <div style={{ marginBottom: "10px", display: "flex", flexWrap: "wrap", gap: "10px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <div style={{ width: "20px", height: "20px", backgroundColor: "#cffbd1", border: "1px solid #aaa" }}></div>
          <span>ENTRADA</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <div style={{ width: "20px", height: "20px", backgroundColor: "#93c1ff", border: "1px solid #aaa" }}></div>
          <span>SALIDA</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <div style={{ width: "20px", height: "20px", backgroundColor: "#ffb4b4", border: "1px solid #aaa" }}></div>
          <span>DAÑADO</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <div style={{ width: "20px", height: "20px", backgroundColor: "#a67eff", border: "1px solid #aaa" }}></div>
          <span>DESTRUCCIÓN</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <div style={{ width: "20px", height: "20px", backgroundColor: "#ffc17e", border: "1px solid #aaa" }}></div>
          <span>RENTA</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <div style={{ width: "20px", height: "20px", backgroundColor: "#55c928ff", border: "1px solid #aaa" }}></div>
          <span>REPARACION</span>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <div style={{ width: "20px", height: "20px", backgroundColor: "#c93328", border: "1px solid #aaa" }}></div>
          <span>EXTRAVIADO</span>
        </div>
      </div>

      {filteredProducto.length === 0 ? (
        <p>{error || (filterText.trim() ? "Sin resultados para la búsqueda." : "Cargando datos...")}</p>
      ) : (
      <div className="product-grid">
        {filteredProducto.slice(0, 18).map((producto) => {
          const cardStyle = {
            backgroundColor: 
              producto.estado === "ENTRADA" ? "#cffbd1" :
              producto.estado === "SALIDA" ? "#93c1ff" :
              producto.estado === "REPARACION" ? "#55c928ff" :
              producto.estado === "DAÑADO" ? "#ffb4b4" :
              producto.estado === "DESTRUCCION" ? "#a67eff" :
              producto.estado === "RENTA" ? "#ffc17e" :
              producto.estado === "EXTRAVIADO" ? "#c93328" :
              "#dcdcdc", // Default color
            fontSize: "15px"
          };

          return (
            <div key={producto.id} className="product-card" style={cardStyle}>
              <div className="card-header">
                <button onClick={() => handleEdit(producto)} className="button-blue">Editar</button>
                {canReturnProducto(producto) && (
                  <button onClick={() => handleReturn(producto)} className="button-gray">Regresar</button>
                )}
                <button onClick={() => handleDetalles(producto)}  className="button-gray">Historial</button>
                <button onClick={() => handleDelete(producto.id)} className="button-table-red">Eliminar</button>
              </div>
              <h2>{producto.descripcion} ({producto.estado})</h2>
              <p><strong>ID:</strong> {producto.id}   <strong>Familia:</strong> {producto.familia}<br></br>
              <strong>Tipo:</strong> {producto.familia_tipo}<br></br>
              <strong>Marca:</strong> {producto.marca}<br></br>
              <strong>Ubicación:</strong> {producto.ubicacion}<br></br>
              <strong>Código:</strong> {producto.codigo} <strong>Color:</strong> {producto.color}<br></br>
              <strong>Nota:</strong> {producto.nota}<br></br>
              <strong>Cantidad:</strong> {producto.cantidad}<br></br>
              <strong>Creacion:</strong> {producto.fecha_creacion}<br></br>
              <hr></hr><strong>Responsable:</strong> {producto.responsable || "Sin asignación"}<br></br>
              <strong>Ultima Actualizacion:</strong> {producto.fecha_ultima_actualizacion}</p>
              <button onClick={() => handleView(producto.path_imagen)} className="button-gray">
                <img 
                  src={`${URL}${producto.path_imagen}?${Date.now()}`}
                  alt="Producto sin imagen"
                  width="250px"
                  />
              </button>
            </div>
          );
        })}
      </div>
      )}
      {/* Modal only shows when `open` is true */}
      {open && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={handleCloseModal}>
              ✖
            </button>
            <img
              src={imageUrl}
              alt="Product"
              className="modal-image"
            />
          </div>
        </div>
      )}
      {historia && (
        <div className="modal-overlay" onClick={handleCloseHistoriaModal}>
          <div className="modal-historia-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={handleCloseHistoriaModal}>
              ✖
            </button>
            <div><h2>Detalles de incidente {idSeleccionado}:</h2>
            <h3>Ubicacion actual {donde}:</h3></div>
            <div>
            <table className="table-de-modal">
              <thead>
                <tr>
                  <th># Vale</th>
                  <th>Responsable</th>
                  <th>Estado</th>
                  <th>Nota</th>
                  <th>Tipo</th>
                  <th>Fecha Creación</th>
                  <th>Fecha Cierre</th>
                </tr>
              </thead>
              <tbody>
                {incidentes.map((incidente, index) => (
                  <tr key={index}>
                    <td>{incidente.id_incidente}</td>
                    <td>{incidente.responsable}</td>
                    <td>{incidente.estado}</td>
                    <td>{incidente.nota}</td>
                    <td>{incidente.tipo_incidente}</td>
                    <td>{incidente.fecha_creacion}</td>
                    <td>
                      {incidente.fecha_cierre === "1990-01-01 00:00:00" ? "" : incidente.fecha_cierre}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table></div>
            
          </div>
        </div>
      )}

    </div>
    
  );
};

FilterTableProducto.propTypes = {
  producto: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      descripcion: PropTypes.string,
    })
  ),
};

export default FilterTableProducto;
